'use strict';

var Sugar = require('sugar-core');

Sugar.Date.defineInstance({

  'iso': function(date) {
    return date.toISOString();
  }

});

module.exports = Sugar.Date.iso;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/iso.js
// module id = 332
// module chunks = 0